type Tamanho = 0 | '0' // 0px
    | 'half' | 1 | '1'  // 4px
    | 'base' | 2 | '2'  // 8px
    | 'baseh' // 12px
    | '2x' | 3 // 16px
    | '2xh' // 20px
    | '3x' | 4 // 24px
    | '3xh' // 28px
    | '4x' | 5 // 32px
    | '4xh' // 36px
    | '5x' | 6 // 40px
    | '5xh' // 44px
    | '5xh'	// 44px
    | '6x'	// 48px
    | '6xh'	// 52px
    | '7x'	// 56px
    | '7xh'	// 60px
    | '8x'	// 64px
    | '8xh'	// 68px
    | '9x'	// 72px
    | '9xh'	// 76px
    | '10x'	// 80px
    | '10xh' // 84px

type FontWeight = 400 | 500 | 600 | 900
type ColorWeight = 5 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90

type Colors = 'interactive' | 'danger' | 'warning' | 'success' | 'info'
    | 'pure'
    | 'gray' | 'gray-cool' | 'gray-warm'
    | 'red' | 'red-cool' | 'red-warm' | 'red-vivid' | 'red-cool-vivid' | 'red-warm-vivid'
    | 'green' | 'green-cool' | 'green-warm' | 'green-vivid' | 'green-cool-vivid' | 'green-warm-vivid'
    | 'blue' | 'blue-cool' | 'blue-warm' | 'blue-vivid' | 'blue-cool-vivid' | 'blue-warm-vivid'
    | 'indigo' | 'indigo-cool' | 'indigo-warm' | 'indigo-vivid' | 'indigo-cool-vivid' | 'indigo-warm-vivid'
    | 'cyan' | 'cyan-vivid'
    | 'gold' | 'gold-vivid'
    | 'magenta' | 'magenta-vivid'
    | 'mint' | 'mint-cool' | 'mint-vivid' | 'mint-cool-vivid'
    | 'orange' | 'orange-warm' | 'orange-vivid' | 'orange-warm-vivid'
    | 'violet' | 'violet-warm' | 'violet-vivid' | 'violet-warm-vivid'
    | 'yellow' | 'mint-vivid'

function textBody(color: Colors, weight: FontWeight) {
    return `text-${color}-${weight}`
}

function textColor(color: Colors, weight: ColorWeight) {
    return `text-${color}-${weight}`
}

function borderColor(color: Colors, weight: ColorWeight) {
    return `border-${color}-${weight}`
}

function bgColor(color: Colors, weight: ColorWeight) {
    return `border-${color}-${weight}`
}

function order(v: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12) {
    return `order-${v}`
}

export default {
    // Gov-br
    row: 'row',
    colMd: 'col-md',
    brModalBody: 'br-modal-body',
    brCard: 'br-card',
    brCardHeader: 'card-header',
    brCardContent: 'card-content',

    // Icons
    iconCharBar: 'chart-bar',
    iconAdjust: 'adjust',

    // Background
    bgColor,

    // Border
    borderColor,

    // Custom
    reset: 'reset',

    textXs: 'text-xs',
    textSm: 'text-sm',
    textLg: 'text-lg',

    textGray400: textBody('gray', 400),
    textGray500: textBody('gray', 500),
    textGray600: textBody('gray', 600),
    textGray900: textBody('gray', 900),
    textColor,

    // Alinhamento
    textCenter: 'text-center',
    textJustify: 'text-justify',
    textLeft: 'text-left',
    textRight: 'text-right',

    // Wrap e overflow
    textWrap: 'text-wrap',
    textNoWrap: 'text-nowrap',
    textTruncate: 'text-truncate',
    textBreak: 'text-break',
    textBreakAll: 'text-break-all',

    // Transformacao
    textLowercase: 'text-lowercase',
    textUppercase: 'text-uppercase',
    textCapitalize: 'text-capitalize',

    // Peso
    textWeightThin: 'text-weight-thin',
    textWeightExtraLight: 'text-weight-extra-light',
    textWeightLight: 'text-weight-light',
    textWeightRegular: 'text-weight-regular',
    textWeightMedium: 'text-weight-medium',
    textWeightSemiBold: 'text-weight-semi-bold',
    textWeightBold: 'text-weight-bold',
    textWeightExtraBold: 'text-weight-extra-bold',
    textWeightBlack: 'text-weight-black',

    fontMono: 'font-mono',

    // Tamanho
    textBase: 'text-base',
    textUp01: 'text-up-01',
    textUp02: 'text-up-02',
    textUp03: 'text-up-03',
    textUp04: 'text-up-04',
    textUp05: 'text-up-05',
    textUp06: 'text-up-06',
    textUp07: 'text-up-07',
    textDown01: 'text-down-01',
    textDown02: 'text-down-02',
    textDown03: 'text-down-03',

    // Display
    dNone: 'd-none',
    dBlock: 'd-block',
    dFlex: 'd-flex',
    dInline: 'd-inline',
    dInlineBlock: 'd-inline-block',
    dInlineFlex: 'd-inline-flex',
    dFlexV: 'd-flex flex-row',
    dFlexH: 'd-flex flex-column',
    flexRow: 'flex-row',
    flexRowReverse: 'flex-row-reverse',
    flexColumn: 'flex-column',
    flexColumnReverse: 'flex-column-reverse',
    flexColumnGapBase: 'flex-column-gap-base',
    flexGrow0: 'flex-grow-0',
    flexGrow1: 'flex-grow-1',
    flexShrink0: 'flex-shrink-0',
    flexShrink1: 'flex-shrink-1',
    order,
    alignContentStart: 'align-content-start',
    alignContentEnd: 'align-content-end',
    alignContentCenter: 'align-content-center',
    alignContentBetween: 'align-content-between',
    alignContentAround: 'align-content-around',
    alignContentEvenly: 'align-content-evenly',
    alignContentStretch: 'align-content-stretch',

    // Padding
    p: (v: Tamanho) => `p-${v}`,
    pSm: (v: Tamanho) => `p-sm-${v}`,
    pMd: (v: Tamanho) => `p-md-${v}`,
    pLg: (v: Tamanho) => `p-lg-${v}`,
    pXl: (v: Tamanho) => `p-xl-${v}`,

    // Padding X
    px: (v: Tamanho) => `px-${v}`,
    pxSm: (v: Tamanho) => `px-sm-${v}`,
    pxMd: (v: Tamanho) => `px-md-${v}`,
    pxLg: (v: Tamanho) => `px-lg-${v}`,
    pxXl: (v: Tamanho) => `px-xl-${v}`,

    // Padding Y
    py: (v: Tamanho) => `py-${v}`,
    pySm: (v: Tamanho) => `py-sm-${v}`,
    pyMd: (v: Tamanho) => `py-md-${v}`,
    pyLg: (v: Tamanho) => `py-lg-${v}`,
    pyXl: (v: Tamanho) => `py-xl-${v}`,

    // Padding Right
    pr: (v: Tamanho) => `pr-${v}`,
    prSm: (v: Tamanho) => `pr-sm-${v}`,
    prMd: (v: Tamanho) => `pr-md-${v}`,
    prLg: (v: Tamanho) => `pr-lg-${v}`,
    prXl: (v: Tamanho) => `pr-xl-${v}`,

    // Padding Top
    pt: (v: Tamanho) => `pt-${v}`,
    ptSm: (v: Tamanho) => `pt-sm-${v}`,
    ptMd: (v: Tamanho) => `pt-md-${v}`,
    ptLg: (v: Tamanho) => `pt-lg-${v}`,
    ptXl: (v: Tamanho) => `pt-xl-${v}`,

    // Padding Left
    pl: (v: Tamanho) => `pl-${v}`,
    plSm: (v: Tamanho) => `pl-sm-${v}`,
    plMd: (v: Tamanho) => `pl-md-${v}`,
    plLg: (v: Tamanho) => `pl-lg-${v}`,
    plXl: (v: Tamanho) => `pl-xl-${v}`,

    // Padding Bottom
    pb: (v: Tamanho) => `pb-${v}`,
    pbSm: (v: Tamanho) => `pb-sm-${v}`,
    pbMd: (v: Tamanho) => `pb-md-${v}`,
    pbLg: (v: Tamanho) => `pb-lg-${v}`,
    pbXl: (v: Tamanho) => `pb-xl-${v}`,

    // Margin
    mInherited: 'm-inherit',
    m: (v: Tamanho) => `m-${v}`,
    mSm: (v: Tamanho) => `m-sm-${v}`,
    mMd: (v: Tamanho) => `m-md-${v}`,
    mLg: (v: Tamanho) => `m-lg-${v}`,
    mXl: (v: Tamanho) => `m-xl-${v}`,

    // Margin X
    mx: (v: Tamanho) => `mx-${v}`,
    mxSm: (v: Tamanho) => `mx-sm-${v}`,
    mxMd: (v: Tamanho) => `mx-md-${v}`,
    mxLg: (v: Tamanho) => `mx-lg-${v}`,
    mxXl: (v: Tamanho) => `mx-xl-${v}`,

    // Margin Y
    my: (v: Tamanho) => `my-${v}`,
    mySm: (v: Tamanho) => `my-sm-${v}`,
    myMd: (v: Tamanho) => `my-md-${v}`,
    myLg: (v: Tamanho) => `my-lg-${v}`,
    myXl: (v: Tamanho) => `my-xl-${v}`,

    // Margin Right
    mr: (v: Tamanho) => `mr-${v}`,
    mrSm: (v: Tamanho) => `mr-sm-${v}`,
    mrMd: (v: Tamanho) => `mr-md-${v}`,
    mrLg: (v: Tamanho) => `mr-lg-${v}`,
    mrXl: (v: Tamanho) => `mr-xl-${v}`,

    // Margin Top
    mt: (v: Tamanho) => `mt-${v}`,
    mtSm: (v: Tamanho) => `mt-sm-${v}`,
    mtMd: (v: Tamanho) => `mt-md-${v}`,
    mtLg: (v: Tamanho) => `mt-lg-${v}`,
    mtXl: (v: Tamanho) => `mt-xl-${v}`,

    // Margin Bottom
    mb: (v: Tamanho) => `mb-${v}`,
    mbSm: (v: Tamanho) => `mb-sm-${v}`,
    mbMd: (v: Tamanho) => `mb-md-${v}`,
    mbLg: (v: Tamanho) => `mb-lg-${v}`,
    mbXl: (v: Tamanho) => `mb-xl-${v}`,

    // Margin Left
    ml: (v: Tamanho) => `ml-${v}`,
    mlSm: (v: Tamanho) => `ml-sm-${v}`,
    mlMd: (v: Tamanho) => `ml-md-${v}`,
    mlLg: (v: Tamanho) => `ml-lg-${v}`,
    mlXl: (v: Tamanho) => `ml-xl-${v}`,

    noGridGlutter: 'no-grid-glutter',
    placeHolder: 'place-holder',
    primeiroBrCardNoShadow: 'primeiro-br-card-no-shadow',

    bgTransparent: 'bg-transparent',
    noBgButton: 'border-solid-none bg-transparent',

    lifeshubList: 'lifeshub-list',
    textPrimary: 'text-primary'
}